import { formatDate as baseFormat } from '~/helpers/formatDate';

export const formatHistoryDate = (date: string | undefined) =>
  baseFormat(date, 'PP');

export function extractDate(iso: string) {
  return formatHistoryDate(iso);
}

/**
 * Calendar-day comparison for job history / feed grouping.
 * Missing timestamps are treated as the same so a date header is not repeated.
 */
export function isSameDate(
  a: string | null | undefined,
  b: string | null | undefined
) {
  if (!(a && b)) return true;
  return extractDate(a) === extractDate(b);
}
